import {
    BLOCKS as CONTENTFUL_BLOCKS,
    MARKS as CONTENTFUL_MARKS,
    Block as ContentfulRichTextBlock,
    Node as ContentfulRichTextNode,
    Text as ContentfulRichTextText,
} from '@contentful/rich-text-types';
import { RichTextNode as PurpurRichTextBlock, RichTextNode, richToPlainText } from '@purpur/library';

const BLOCK_TYPES_CONTENTFUL_TO_PURPUR = {
    [CONTENTFUL_BLOCKS.DOCUMENT]: 'document',
    [CONTENTFUL_BLOCKS.PARAGRAPH]: 'paragraph',
    [CONTENTFUL_BLOCKS.HEADING_1]: 'header-1',
    [CONTENTFUL_BLOCKS.HEADING_2]: 'header-2',
    [CONTENTFUL_BLOCKS.HEADING_3]: 'header-3',
    [CONTENTFUL_BLOCKS.HEADING_4]: 'header-4',
    [CONTENTFUL_BLOCKS.HEADING_5]: 'header-5',
    [CONTENTFUL_BLOCKS.HEADING_6]: 'header-6',
    [CONTENTFUL_BLOCKS.OL_LIST]: 'ordered-list',
    [CONTENTFUL_BLOCKS.UL_LIST]: 'unordered-list',
    [CONTENTFUL_BLOCKS.LIST_ITEM]: 'list-item',
    [CONTENTFUL_BLOCKS.HR]: 'horizontal-row',
    [CONTENTFUL_BLOCKS.QUOTE]: 'blockquote',
    [CONTENTFUL_BLOCKS.EMBEDDED_ASSET]: 'embedded-asset-block',
    [CONTENTFUL_BLOCKS.TABLE]: 'table',
    [CONTENTFUL_BLOCKS.TABLE_ROW]: 'table-row',
    [CONTENTFUL_BLOCKS.TABLE_CELL]: 'table-cell',
    [CONTENTFUL_BLOCKS.TABLE_HEADER_CELL]: 'table-header-cell',
    text: 'text',
    hyperlink: 'hyperlink',
};

const SUPPORTED_MARK: CONTENTFUL_MARKS[] = [
    CONTENTFUL_MARKS.BOLD,
    CONTENTFUL_MARKS.ITALIC,
    CONTENTFUL_MARKS.UNDERLINE,
    CONTENTFUL_MARKS.CODE,
    CONTENTFUL_MARKS.STRIKETHROUGH,
    CONTENTFUL_MARKS.SUPERSCRIPT,
    CONTENTFUL_MARKS.SUBSCRIPT,
];

export const convertContentfulRichTextToPurpur = (
    richTextBlock: ContentfulRichTextNode,
): PurpurRichTextBlock | null => {
    const blockNodeType = richTextBlock.nodeType as keyof typeof BLOCK_TYPES_CONTENTFUL_TO_PURPUR;
    const mappedType = BLOCK_TYPES_CONTENTFUL_TO_PURPUR[blockNodeType] as PurpurRichTextBlock['type'];
    if (!mappedType) {
        return null;
    }

    return {
        type: mappedType,
        content: (richTextBlock as ContentfulRichTextBlock).content
            ?.map(convertContentfulRichTextToPurpur)
            .filter<RichTextNode>((value): value is RichTextNode => value !== null),
        value: (richTextBlock as ContentfulRichTextText).value,
        marks: (richTextBlock as ContentfulRichTextText).marks
            ?.map((mark) => (SUPPORTED_MARK.includes(mark.type as CONTENTFUL_MARKS) ? (mark.type as any) : null))
            .filter(Boolean),
        uri: richTextBlock.data?.uri,
        data: richTextBlock.data,
    };
};

export const convertContentfulRichTextToPlainText = (richTextBlock?: ContentfulRichTextNode): string => {
    if (!richTextBlock) {
        return '';
    }
    const purpurRichText = convertContentfulRichTextToPurpur(richTextBlock);
    if (!purpurRichText) {
        return '';
    }
    const richTextJson = JSON.stringify(purpurRichText);

    return richToPlainText(richTextJson);
};
